// Maps IANA timezone strings to default map center coordinates
// Used to center the map on the correct region when no GPS data is available

export const TIMEZONE_COORDS = {
  // Middle East
  "Asia/Dubai":       { lat: 25.2048,  lng: 55.2708,   zoom: 11 },
  "Asia/Riyadh":      { lat: 24.7136,  lng: 46.6753,   zoom: 11 },
  "Asia/Kuwait":      { lat: 29.3759,  lng: 47.9774,   zoom: 11 },
  "Asia/Qatar":       { lat: 25.2854,  lng: 51.5310,   zoom: 11 },
  "Asia/Bahrain":     { lat: 26.0667,  lng: 50.5577,   zoom: 11 },
  "Asia/Muscat":      { lat: 23.5880,  lng: 58.3829,   zoom: 11 },
  "Asia/Baghdad":     { lat: 33.3152,  lng: 44.3661,   zoom: 11 },
  "Asia/Beirut":      { lat: 33.8886,  lng: 35.4955,   zoom: 11 },
  "Asia/Amman":       { lat: 31.9454,  lng: 35.9284,   zoom: 11 },
  "Asia/Damascus":    { lat: 33.5138,  lng: 36.2765,   zoom: 11 },
  "Asia/Jerusalem":   { lat: 31.7683,  lng: 35.2137,   zoom: 11 },
  "Asia/Aden":        { lat: 12.7797,  lng: 45.0187,   zoom: 11 },

  // North Africa
  "Africa/Casablanca": { lat: 33.5731,  lng: -7.5898,   zoom: 11 },
  "Africa/Algiers":    { lat: 36.7372,  lng: 3.0865,    zoom: 11 },
  "Africa/Tunis":      { lat: 36.8190,  lng: 10.1658,   zoom: 11 },
  "Africa/Tripoli":    { lat: 32.9012,  lng: 13.1800,   zoom: 11 },
  "Africa/Cairo":      { lat: 30.0444,  lng: 31.2357,   zoom: 11 },
  "Africa/Khartoum":   { lat: 15.5007,  lng: 32.5599,   zoom: 11 },

  // West Africa
  "Africa/Dakar":      { lat: 14.7167,  lng: -17.4677,  zoom: 11 },
  "Africa/Abidjan":    { lat: 5.3600,   lng: -4.0083,   zoom: 11 },
  "Africa/Accra":      { lat: 5.6037,   lng: -0.1870,   zoom: 11 },
  "Africa/Lagos":      { lat: 6.5244,   lng: 3.3792,    zoom: 11 },
  "Africa/Bamako":     { lat: 12.6392,  lng: -8.0029,   zoom: 11 },
  "Africa/Conakry":    { lat: 9.5370,   lng: -13.6773,  zoom: 11 },
  "Africa/Douala":     { lat: 4.0511,   lng: 9.7679,    zoom: 11 },

  // East Africa
  "Africa/Nairobi":       { lat: -1.2921,  lng: 36.8219,  zoom: 11 },
  "Africa/Addis_Ababa":   { lat: 9.0320,   lng: 38.7469,  zoom: 11 },
  "Africa/Dar_es_Salaam": { lat: -6.7924,  lng: 39.2083,  zoom: 11 },
  "Africa/Kampala":       { lat: 0.3476,   lng: 32.5825,  zoom: 11 },

  // Southern Africa
  "Africa/Johannesburg": { lat: -26.2041, lng: 28.0473,  zoom: 11 },
  "Africa/Lusaka":       { lat: -15.4166, lng: 28.2833,  zoom: 11 },
  "Africa/Harare":       { lat: -17.8252, lng: 31.0335,  zoom: 11 },

  // Europe
  "Europe/London":    { lat: 51.5074,  lng: -0.1278,   zoom: 11 },
  "Europe/Paris":     { lat: 48.8566,  lng: 2.3522,    zoom: 11 },
  "Europe/Berlin":    { lat: 52.5200,  lng: 13.4050,   zoom: 11 },
  "Europe/Madrid":    { lat: 40.4168,  lng: -3.7038,   zoom: 11 },
  "Europe/Rome":      { lat: 41.9028,  lng: 12.4964,   zoom: 11 },
  "Europe/Istanbul":  { lat: 41.0082,  lng: 28.9784,   zoom: 11 },
  "Europe/Moscow":    { lat: 55.7558,  lng: 37.6176,   zoom: 11 },
  "Europe/Amsterdam": { lat: 52.3676,  lng: 4.9041,    zoom: 11 },
  "Europe/Brussels":  { lat: 50.8503,  lng: 4.3517,    zoom: 11 },
  "Europe/Zurich":    { lat: 47.3769,  lng: 8.5417,    zoom: 11 },
  "Europe/Stockholm": { lat: 59.3293,  lng: 18.0686,   zoom: 11 },

  // Asia
  "Asia/Karachi":    { lat: 24.8607,  lng: 67.0011,   zoom: 11 },
  "Asia/Kolkata":    { lat: 22.5726,  lng: 88.3639,   zoom: 11 },
  "Asia/Dhaka":      { lat: 23.8103,  lng: 90.4125,   zoom: 11 },
  "Asia/Colombo":    { lat: 6.9271,   lng: 79.8612,   zoom: 11 },
  "Asia/Bangkok":    { lat: 13.7563,  lng: 100.5018,  zoom: 11 },
  "Asia/Singapore":  { lat: 1.3521,   lng: 103.8198,  zoom: 11 },
  "Asia/Shanghai":   { lat: 31.2304,  lng: 121.4737,  zoom: 11 },
  "Asia/Tokyo":      { lat: 35.6762,  lng: 139.6503,  zoom: 11 },
  "Asia/Seoul":      { lat: 37.5665,  lng: 126.9780,  zoom: 11 },

  // Americas
  "America/New_York":    { lat: 40.7128,  lng: -74.0060,  zoom: 11 },
  "America/Chicago":     { lat: 41.8781,  lng: -87.6298,  zoom: 11 },
  "America/Denver":      { lat: 39.7392,  lng: -104.9903, zoom: 11 },
  "America/Los_Angeles": { lat: 34.0522,  lng: -118.2437, zoom: 11 },
  "America/Sao_Paulo":   { lat: -23.5505, lng: -46.6333,  zoom: 11 },
  "America/Mexico_City": { lat: 19.4326,  lng: -99.1332,  zoom: 11 },

  // Default fallback
  "UTC": { lat: 25.2048, lng: 55.2708, zoom: 4 },
};

export function getMapCenter(timezone) {
  return TIMEZONE_COORDS[timezone] || TIMEZONE_COORDS["Asia/Dubai"];
}
